import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/daily", label: "每日日报" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="hidden md:block bg-foreground-950 text-background-100">
        <div className="px-4 md:px-8 h-9 flex items-center justify-between text-xs">
          <p className="tracking-wide">
            <i className="ri-calendar-line mr-1" />
            2026 年 9 月 10 日 · 第 286 期日报已更新
          </p>
          <p className="text-background-300">
            <i className="ri-refresh-line mr-1" />
            编辑部每日 09:00 前完成汇总
          </p>
        </div>
      </div>

      <div className="px-4 md:px-8">
        <div className="h-16 md:h-[72px] flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
            <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
              <i className="ri-fire-fill text-background-50 text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-black text-xl text-foreground-950 tracking-tight">
                黑料今日
              </span>
              <span className="text-[10px] text-foreground-500 tracking-[0.3em] mt-0.5">
                DAILY DIGEST
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3.5 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "text-primary-600 font-semibold bg-primary-50"
                      : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/daily"
              className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 text-sm rounded-md bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-bookmark-line" />
              订阅日报
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <nav
          className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3 flex flex-col gap-1"
          aria-label="移动端导航"
        >
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `px-3 py-2.5 text-sm rounded-md cursor-pointer ${
                  isActive
                    ? "text-primary-600 font-semibold bg-primary-50"
                    : "text-foreground-700 hover:bg-background-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/daily"
            onClick={() => setOpen(false)}
            className="mt-1 px-3 py-2.5 text-sm rounded-md bg-primary-500 text-background-50 text-center font-medium cursor-pointer"
          >
            订阅日报
          </Link>
        </nav>
      )}
    </header>
  );
}